import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logoIcon from "../../assets/logo-icon.png";
import { HEADER } from "../../data/startPageContent";
import "./StartHeader.css";

/** Slim sticky header: logo · כניסה · one CTA (plan §4.0). */
export default function StartHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`st-header${scrolled ? " st-header--scrolled" : ""}`}>
      <div className="st-container st-header-inner">
        <Link to="/" className="st-header-logo" aria-label={HEADER.logoAlt}>
          <span className="st-header-logo-text">CliniKit</span>
          <img src={logoIcon} alt="" className="st-header-logo-icon" width="28" height="28" />
        </Link>
        <nav className="st-header-nav" aria-label="ניווט">
          <Link to="/login" className="st-header-login">
            {HEADER.login}
          </Link>
          <a href="#start-form" className="st-btn st-btn--primary st-header-cta">
            <span className="st-header-cta-full">{HEADER.cta}</span>
            <span className="st-header-cta-short">{HEADER.ctaShort}</span>
          </a>
        </nav>
      </div>
    </header>
  );
}
